import type { DispatchActions, State } from './types';
import { DispatchActionsType } from './types';

export const reducer = (state: State, action: DispatchActions) => {
  switch (action.type) {
    case DispatchActionsType.SET_CART:
      return { ...state, cart: action.payload, cartLoading: false };
    case DispatchActionsType.SET_DELIVERY_DATES:
      return {
        ...state,
        deliveryDates: action.payload,
        deliveryDatesLoading: false,
      };
    case DispatchActionsType.SET_ALL_LOADING:
      return {
        ...state,
        cartLoading: action.payload,
        deliveryDatesLoading: action.payload,
      };
    case DispatchActionsType.SET_CART_LOADING:
      return {
        ...state,
        cartLoading: action.payload,
      };
    case DispatchActionsType.SET_DELIVERY_DATES_LOADING:
      return {
        ...state,
        deliveryDatesLoading: action.payload,
      };
    case DispatchActionsType.SET_ERRORS:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
